"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const vue_3 = require("vue");
exports.default = (0, vue_1.defineComponent)({
    __name: 'GoogleMap',
    props: {
        lat: {
            type: Number,
        },
        lng: {
            type: Number,
        },
    },
    setup(__props) {
        const props = __props;
        const mapEl = (0, vue_3.ref)();
        (0, vue_3.onMounted)(() => {
            if (typeof google === 'undefined' || typeof google.maps === 'undefined') {
                const s = document.createElement('script');
                const key = process.env.MIX_GOOGLE_MAPS_API_KEY;
                const src = `https://maps.googleapis.com/maps/api/js?key=${key}`;
                s.setAttribute('src', src);
                s.addEventListener('load', () => {
                    setupMap();
                });
                document.body.appendChild(s);
            }
            else {
                setupMap();
            }
        });
        function setupMap() {
            const zoom = 14;
            const center = {
                lat: props.lat,
                lng: props.lng,
            };
            const map = new google.maps.Map(mapEl.value, {
                zoom,
                center,
            });
            const icon = `${window.location.origin}/img/icon-marker.png`;
            new google.maps.Marker({
                position: center,
                map,
                icon,
            });
        }
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                class: "rounded-3xl bg-gray-100 h-96 flex items-center justify-center",
                ref_key: "mapEl",
                ref: mapEl
            }, null, 512));
        };
    }
});
